export function formatDollarPrice(value: number | null | undefined, includeSymbol = false): string {
  if (value === null || value === undefined || !Number.isFinite(value) || value < 0) return '—';
  const rounded = Math.round(value * 1000) / 1000;
  const isExtreme = rounded < 0.1 || rounded > 0.9;
  const decimals = isExtreme && Math.round(rounded * 1000) % 10 !== 0 ? 3 : 2;
  return `${includeSymbol ? '$' : ''}${rounded.toFixed(decimals)}`;
}

export function formatPercentPrice(value: number | null | undefined, exchange?: string): string | null {
  if (value === null || value === undefined || isNaN(value) || value === -1 || !isFinite(value)) {
    return null;
  }
  const shouldMultiplyBy100 = value < 1 || exchange === undefined || exchange === 'FORECASTX';
  const cents = shouldMultiplyBy100 ? Math.round(value * 1000) / 10 : Math.round(value * 10) / 10;
  const isExtreme = Math.abs(cents) < 10 || Math.abs(cents) > 90;
  if (isExtreme && cents % 1 !== 0) return `${cents}%`;
  return `${Math.round(cents)}%`;
}
// last modified by AI tools on 2026-10-12
